import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";

class Spinner extends Component {
	render({className, style, block}) {
		return (
			<section
				className={combineClasses(
					"spinner",
					block && "block",
					className
				)}
				style={style}
			>
				{
					Array(9).fill(null).map((_, i) => (
						<div key={i} className={`spinner-cube spinner-cube${i + 1}`}/>
					))
				}
			</section>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,

			block: PropTypes.bool,
		}
	}

	static get defaultProps() {
		return {
			block: false,
		}
	}
}

export default Spinner;
